import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@mui/material";
import generateMuiTheme from "./Meeting/mui/theme";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import store from "./redux/store";

import { CometChatUIKit, UIKitSettingsBuilder } from "@cometchat/chat-uikit-react";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import { metaInfo } from "./CometChat/metaInfo";
import { setupLocalization } from "./CometChat/utils/utils";

// Helper function to get current browser theme
const getBrowserTheme = (): "light" | "dark" => {
  const isDarkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return isDarkTheme ? "dark" : "light";
};

// Get CometChat credentials
const appID = process.env.REACT_APP_COMETCHAT_APP_ID || (localStorage.getItem("appId") ?? "");
const region = process.env.REACT_APP_COMETCHAT_APP_REGION || (localStorage.getItem("region") ?? "");
const authKey = process.env.REACT_APP_COMETCHAT_AUTH_KEY || (localStorage.getItem("authKey") ?? "");


const root = ReactDOM.createRoot(document.getElementById("root"));

setupLocalization(); // initialize translations/localization

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
        <ThemeProvider theme={generateMuiTheme()}>
          <App theme={getBrowserTheme()} />
          <ToastContainer />
        </ThemeProvider>
      </GoogleOAuthProvider>
    </Provider>
  );
};

if (appID && region && authKey) {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(appID)
    .setRegion(region)
    .setAuthKey(authKey)
    .subscribePresenceForAllUsers()
    .build();

  CometChatUIKit.init(uiKitSettings)
    ?.then(() => {
      console.log("CometChat UI Kit initialized successfully.");
      try {
        CometChat.setDemoMetaInfo(metaInfo);
      } catch (err) {
        console.error("Failed to set meta info:", err);
      }
      renderApp();
    })
    .catch((error) => {
      console.error("Failed to initialize CometChat UI Kit:", error);
      renderApp(); // Still render the app even if CometChat init fails
    });
} else {
  console.warn("CometChat credentials not found. App will load without CometChat integration.");
  renderApp();
}

reportWebVitals();
